export default __webpack_public_path__ + "static/media/whatsapp.a8758e36.svg";